import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Component({
  selector: 'file-extension',
  templateUrl: './file-extension.component.html',
  styleUrls: ['./file-extension.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileExtensionComponent implements OnInit {
  @Input() IconName;
  @Input() isActive;
  @Input() largeIcon = false;
  @Input() xLargeIcon = false;
  @Input() xLargeIcon36 = false;
  @Input() setHomePageIcon = false;

  constructor() {}

  ngOnInit(): void {
    this.IconName = this.IconName.toLowerCase();
  }
}
